import React, { useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { WALKTHROUGH_HISTORY_STATE_KEY } from "../utils/walkthroughEvents";

// Create a context to share form dirty state across components
export const FormDirtyContext = React.createContext({
	isDirty: false,
	setIsDirty: () => {},
	changes: [],
	setChanges: () => {}
});

const BottomNavBar = () => {
  const isTherapist = localStorage.getItem("is_therapist") === "true";
  const userId = localStorage.getItem("user_id");
  const location = useLocation();
  const navigate = useNavigate();
  const isWalkthroughActive = Boolean(
    location.state?.[WALKTHROUGH_HISTORY_STATE_KEY]?.key
  );
  
  // Connect to the FormDirtyContext
  const { isDirty, changes } = useContext(FormDirtyContext)
  
  // State for modal
  const [showModal, setShowModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  // Handle navigation with dirty check
  const handleNavigation = (destination) => {
    if (isDirty && !isWalkthroughActive) {
      // Show confirmation modal
      setPendingNavigation(destination);
      setShowModal(true);
    } else {
      // Navigate directly if form isn't dirty
      navigate(destination);
    }
  };

  // Confirm navigation and proceed
  const confirmNavigation = () => {
    setShowModal(false);
    if (pendingNavigation) {
      navigate(pendingNavigation);
      setPendingNavigation(null);
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-between fixed-bottom"
        style={{
          backgroundColor: "#fff",
          zIndex: 999,
          padding: "8px",
        }}
      >
        {/* Clients/Programs Button */}
        <Button
          variant="link"
          onClick={() => handleNavigation(isTherapist ? "/clients" : "/programs")}
          className="w-50 py-3 nav-text text-center rounded-3 text-decoration-none"
          style={{
            marginLeft: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          {isTherapist ? "Clients" : "Programs"}
        </Button>
        
        {/* Profile Button */}
        <Button
          variant="link"
          onClick={() => handleNavigation(`/user/${userId}`)}
          className="w-50 py-3 nav-text text-center rounded-3 text-decoration-none"
          style={{
            marginRight: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          Profile
        </Button>
      </div>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Unsaved Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="mb-2">
              You have unsaved changes:
            </div>

            {Array.isArray(changes) && changes.length > 0 ? (
              <ul className="mb-0">
                {changes.map((c, i) => (
                  <li key={i}>{c}</li>
                ))}
              </ul>
            ) : (
              <div className="text-muted">
                Changes detected.
              </div>
            )}

            <div className="mt-3">
              Are you sure you want to leave this page?
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Stay on Page
          </Button>
          <Button variant="primary" onClick={confirmNavigation}>
            Leave Page
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BottomNavBar;